var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4121 11.8391C12.4121 15.2876 9.63559 18.0831 6.21068 18.0831C2.78576 18.0831 0.00927734 15.2876 0.00927734 11.8391C0.00927734 8.3907 2.78576 5.59521 6.21068 5.59521C9.63559 5.59521 12.4121 8.3907 12.4121 11.8391Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2151 11.8392C19.2151 15.0853 17.827 17.7168 16.1144 17.7168C14.402 17.7168 13.0138 15.0853 13.0138 11.8392C13.0138 8.59308 14.402 5.96161 16.1144 5.96161C17.827 5.96161 19.2151 8.59308 19.2151 11.8392Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9979 11.8392C21.9979 14.7476 21.5096 17.1053 20.9074 17.1053C20.3051 17.1053 19.817 14.7476 19.817 11.8392C19.817 8.93083 20.3051 6.57311 20.9074 6.57311C21.5096 6.57311 21.9979 8.93083 21.9979 11.8392Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumFill);
export default __webpack_public_path__ + "static/media/medium-fill.a24b30f538d6f456b428cac36e15a1a5.svg";
export { ForwardRef as ReactComponent };